import React from "react";
import Box from "@material-ui/core/Box";
import Zoom from "@material-ui/core/Zoom";

import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useTheme } from "@material-ui/core";

export default function BottomSheetHandle({ open, onClick }) {
  const { palette } = useTheme();
  return (
    <>
      <Box height={24} marginTop={-1.5} p={1} onClick={onClick}>
        <Box
          position="absolute"
          left="50%"
          marginLeft={-1.5}
          marginTop={-0.5}
          clone
        >
          <Zoom in={open}>
            <ExpandMoreIcon style={{ color: palette.grey200 }} />
          </Zoom>
        </Box>
        <Box
          position="absolute"
          left="50%"
          marginLeft={-1.5}
          marginTop={-0.5}
          clone
        >
          <Zoom in={!open}>
            <ExpandLessIcon style={{ color: palette.grey200 }} />
          </Zoom>
        </Box>
      </Box>
    </>
    // <Box
    //   width={32}
    //   height={4}
    //   borderRadius={4}
    //   bgcolor="#d4d6db"
    //   margin="0 auto 4px"
    //   display={{ xs: "block", md: "none" }}
    // />
  );
}
